// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';


export type ToggleBuildFlagMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  userId: Types.Scalars['UUID'];
}>;


export type ToggleBuildFlagMutation = (
  { __typename?: 'Mutation' }
  & { toggleBuildFlag?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message'>
  )> }
);

export type ToggleBurstModeEnabledMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type ToggleBurstModeEnabledMutation = (
  { __typename?: 'Mutation' }
  & { toggleBurstModeEnabled?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message'>
  )> }
);

export type TogglePreviewBuildFlagMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  userId: Types.Scalars['UUID'];
}>;


export type TogglePreviewBuildFlagMutation = (
  { __typename?: 'Mutation' }
  & { togglePreviewBuildFlag?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message'>
  )> }
);

export type UpdatePreviewTriggerTypeMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  triggerType: Types.PreviewTriggerType;
}>;


export type UpdatePreviewTriggerTypeMutation = (
  { __typename?: 'Mutation' }
  & { updatePreviewTriggerType?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message'>
  )> }
);

export type ToggleManualHostingDeploysMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type ToggleManualHostingDeploysMutation = (
  { __typename?: 'Mutation' }
  & { toggleManualHostingDeploys?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message'>
  )> }
);

export type ToggleIncrementalBuildFlagMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  userId: Types.Scalars['UUID'];
}>;


export type ToggleIncrementalBuildFlagMutation = (
  { __typename?: 'Mutation' }
  & { toggleIncrementalBuildFlag?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message'>
  )> }
);

export type ToggleIncrementalDeploysProductionEnabledMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type ToggleIncrementalDeploysProductionEnabledMutation = (
  { __typename?: 'Mutation' }
  & { toggleIncrementalDeploysProductionEnabled?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message'>
  )> }
);

export type ToggleMerlinPullRequestsSourcingEnabledMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type ToggleMerlinPullRequestsSourcingEnabledMutation = (
  { __typename?: 'Mutation' }
  & { toggleMerlinPullRequestsSourcingEnabled?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message'>
  )> }
);

export type ToggleSlicesApiEnabledMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type ToggleSlicesApiEnabledMutation = (
  { __typename?: 'Mutation' }
  & { toggleSlicesAPIEnabled?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message'>
  )> }
);

export type ToggleGatsbyjsioEnabledMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type ToggleGatsbyjsioEnabledMutation = (
  { __typename?: 'Mutation' }
  & { toggleGatsbyjsioEnabled?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message'>
  )> }
);


export const ToggleBuildFlagDocument = gql`
    mutation ToggleBuildFlag($siteId: UUID!, $userId: UUID!) {
  toggleBuildFlag(siteId: $siteId, userId: $userId) {
    success
    message
  }
}
    `;
export type ToggleBuildFlagMutationFn = ApolloReactCommon.MutationFunction<ToggleBuildFlagMutation, ToggleBuildFlagMutationVariables>;

/**
 * __useToggleBuildFlagMutation__
 *
 * To run a mutation, you first call `useToggleBuildFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleBuildFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleBuildFlagMutation, { data, loading, error }] = useToggleBuildFlagMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useToggleBuildFlagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleBuildFlagMutation, ToggleBuildFlagMutationVariables>) {
        return ApolloReactHooks.useMutation<ToggleBuildFlagMutation, ToggleBuildFlagMutationVariables>(ToggleBuildFlagDocument, baseOptions);
      }
export type ToggleBuildFlagMutationHookResult = ReturnType<typeof useToggleBuildFlagMutation>;
export type ToggleBuildFlagMutationResult = ApolloReactCommon.MutationResult<ToggleBuildFlagMutation>;
export type ToggleBuildFlagMutationOptions = ApolloReactCommon.BaseMutationOptions<ToggleBuildFlagMutation, ToggleBuildFlagMutationVariables>;
export const ToggleBurstModeEnabledDocument = gql`
    mutation toggleBurstModeEnabled($siteId: UUID!) {
  toggleBurstModeEnabled(siteId: $siteId) {
    success
    message
  }
}
    `;
export type ToggleBurstModeEnabledMutationFn = ApolloReactCommon.MutationFunction<ToggleBurstModeEnabledMutation, ToggleBurstModeEnabledMutationVariables>;

/**
 * __useToggleBurstModeEnabledMutation__
 *
 * To run a mutation, you first call `useToggleBurstModeEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleBurstModeEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleBurstModeEnabledMutation, { data, loading, error }] = useToggleBurstModeEnabledMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useToggleBurstModeEnabledMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleBurstModeEnabledMutation, ToggleBurstModeEnabledMutationVariables>) {
        return ApolloReactHooks.useMutation<ToggleBurstModeEnabledMutation, ToggleBurstModeEnabledMutationVariables>(ToggleBurstModeEnabledDocument, baseOptions);
      }
export type ToggleBurstModeEnabledMutationHookResult = ReturnType<typeof useToggleBurstModeEnabledMutation>;
export type ToggleBurstModeEnabledMutationResult = ApolloReactCommon.MutationResult<ToggleBurstModeEnabledMutation>;
export type ToggleBurstModeEnabledMutationOptions = ApolloReactCommon.BaseMutationOptions<ToggleBurstModeEnabledMutation, ToggleBurstModeEnabledMutationVariables>;
export const TogglePreviewBuildFlagDocument = gql`
    mutation TogglePreviewBuildFlag($siteId: UUID!, $userId: UUID!) {
  togglePreviewBuildFlag(siteId: $siteId, userId: $userId) {
    success
    message
  }
}
    `;
export type TogglePreviewBuildFlagMutationFn = ApolloReactCommon.MutationFunction<TogglePreviewBuildFlagMutation, TogglePreviewBuildFlagMutationVariables>;

/**
 * __useTogglePreviewBuildFlagMutation__
 *
 * To run a mutation, you first call `useTogglePreviewBuildFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePreviewBuildFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePreviewBuildFlagMutation, { data, loading, error }] = useTogglePreviewBuildFlagMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useTogglePreviewBuildFlagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TogglePreviewBuildFlagMutation, TogglePreviewBuildFlagMutationVariables>) {
        return ApolloReactHooks.useMutation<TogglePreviewBuildFlagMutation, TogglePreviewBuildFlagMutationVariables>(TogglePreviewBuildFlagDocument, baseOptions);
      }
export type TogglePreviewBuildFlagMutationHookResult = ReturnType<typeof useTogglePreviewBuildFlagMutation>;
export type TogglePreviewBuildFlagMutationResult = ApolloReactCommon.MutationResult<TogglePreviewBuildFlagMutation>;
export type TogglePreviewBuildFlagMutationOptions = ApolloReactCommon.BaseMutationOptions<TogglePreviewBuildFlagMutation, TogglePreviewBuildFlagMutationVariables>;
export const UpdatePreviewTriggerTypeDocument = gql`
    mutation UpdatePreviewTriggerType($siteId: UUID!, $triggerType: PreviewTriggerType!) {
  updatePreviewTriggerType(siteId: $siteId, triggerType: $triggerType) {
    success
    message
  }
}
    `;
export type UpdatePreviewTriggerTypeMutationFn = ApolloReactCommon.MutationFunction<UpdatePreviewTriggerTypeMutation, UpdatePreviewTriggerTypeMutationVariables>;

/**
 * __useUpdatePreviewTriggerTypeMutation__
 *
 * To run a mutation, you first call `useUpdatePreviewTriggerTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreviewTriggerTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreviewTriggerTypeMutation, { data, loading, error }] = useUpdatePreviewTriggerTypeMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      triggerType: // value for 'triggerType'
 *   },
 * });
 */
export function useUpdatePreviewTriggerTypeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePreviewTriggerTypeMutation, UpdatePreviewTriggerTypeMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePreviewTriggerTypeMutation, UpdatePreviewTriggerTypeMutationVariables>(UpdatePreviewTriggerTypeDocument, baseOptions);
      }
export type UpdatePreviewTriggerTypeMutationHookResult = ReturnType<typeof useUpdatePreviewTriggerTypeMutation>;
export type UpdatePreviewTriggerTypeMutationResult = ApolloReactCommon.MutationResult<UpdatePreviewTriggerTypeMutation>;
export type UpdatePreviewTriggerTypeMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePreviewTriggerTypeMutation, UpdatePreviewTriggerTypeMutationVariables>;
export const ToggleManualHostingDeploysDocument = gql`
    mutation ToggleManualHostingDeploys($siteId: UUID!) {
  toggleManualHostingDeploys(siteId: $siteId) {
    success
    message
  }
}
    `;
export type ToggleManualHostingDeploysMutationFn = ApolloReactCommon.MutationFunction<ToggleManualHostingDeploysMutation, ToggleManualHostingDeploysMutationVariables>;

/**
 * __useToggleManualHostingDeploysMutation__
 *
 * To run a mutation, you first call `useToggleManualHostingDeploysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleManualHostingDeploysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleManualHostingDeploysMutation, { data, loading, error }] = useToggleManualHostingDeploysMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useToggleManualHostingDeploysMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleManualHostingDeploysMutation, ToggleManualHostingDeploysMutationVariables>) {
        return ApolloReactHooks.useMutation<ToggleManualHostingDeploysMutation, ToggleManualHostingDeploysMutationVariables>(ToggleManualHostingDeploysDocument, baseOptions);
      }
export type ToggleManualHostingDeploysMutationHookResult = ReturnType<typeof useToggleManualHostingDeploysMutation>;
export type ToggleManualHostingDeploysMutationResult = ApolloReactCommon.MutationResult<ToggleManualHostingDeploysMutation>;
export type ToggleManualHostingDeploysMutationOptions = ApolloReactCommon.BaseMutationOptions<ToggleManualHostingDeploysMutation, ToggleManualHostingDeploysMutationVariables>;
export const ToggleIncrementalBuildFlagDocument = gql`
    mutation ToggleIncrementalBuildFlag($siteId: UUID!, $userId: UUID!) {
  toggleIncrementalBuildFlag(siteId: $siteId, userId: $userId) {
    success
    message
  }
}
    `;
export type ToggleIncrementalBuildFlagMutationFn = ApolloReactCommon.MutationFunction<ToggleIncrementalBuildFlagMutation, ToggleIncrementalBuildFlagMutationVariables>;

/**
 * __useToggleIncrementalBuildFlagMutation__
 *
 * To run a mutation, you first call `useToggleIncrementalBuildFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleIncrementalBuildFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleIncrementalBuildFlagMutation, { data, loading, error }] = useToggleIncrementalBuildFlagMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useToggleIncrementalBuildFlagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleIncrementalBuildFlagMutation, ToggleIncrementalBuildFlagMutationVariables>) {
        return ApolloReactHooks.useMutation<ToggleIncrementalBuildFlagMutation, ToggleIncrementalBuildFlagMutationVariables>(ToggleIncrementalBuildFlagDocument, baseOptions);
      }
export type ToggleIncrementalBuildFlagMutationHookResult = ReturnType<typeof useToggleIncrementalBuildFlagMutation>;
export type ToggleIncrementalBuildFlagMutationResult = ApolloReactCommon.MutationResult<ToggleIncrementalBuildFlagMutation>;
export type ToggleIncrementalBuildFlagMutationOptions = ApolloReactCommon.BaseMutationOptions<ToggleIncrementalBuildFlagMutation, ToggleIncrementalBuildFlagMutationVariables>;
export const ToggleIncrementalDeploysProductionEnabledDocument = gql`
    mutation ToggleIncrementalDeploysProductionEnabled($siteId: UUID!) {
  toggleIncrementalDeploysProductionEnabled(siteId: $siteId) {
    success
    message
  }
}
    `;
export type ToggleIncrementalDeploysProductionEnabledMutationFn = ApolloReactCommon.MutationFunction<ToggleIncrementalDeploysProductionEnabledMutation, ToggleIncrementalDeploysProductionEnabledMutationVariables>;

/**
 * __useToggleIncrementalDeploysProductionEnabledMutation__
 *
 * To run a mutation, you first call `useToggleIncrementalDeploysProductionEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleIncrementalDeploysProductionEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleIncrementalDeploysProductionEnabledMutation, { data, loading, error }] = useToggleIncrementalDeploysProductionEnabledMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useToggleIncrementalDeploysProductionEnabledMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleIncrementalDeploysProductionEnabledMutation, ToggleIncrementalDeploysProductionEnabledMutationVariables>) {
        return ApolloReactHooks.useMutation<ToggleIncrementalDeploysProductionEnabledMutation, ToggleIncrementalDeploysProductionEnabledMutationVariables>(ToggleIncrementalDeploysProductionEnabledDocument, baseOptions);
      }
export type ToggleIncrementalDeploysProductionEnabledMutationHookResult = ReturnType<typeof useToggleIncrementalDeploysProductionEnabledMutation>;
export type ToggleIncrementalDeploysProductionEnabledMutationResult = ApolloReactCommon.MutationResult<ToggleIncrementalDeploysProductionEnabledMutation>;
export type ToggleIncrementalDeploysProductionEnabledMutationOptions = ApolloReactCommon.BaseMutationOptions<ToggleIncrementalDeploysProductionEnabledMutation, ToggleIncrementalDeploysProductionEnabledMutationVariables>;
export const ToggleMerlinPullRequestsSourcingEnabledDocument = gql`
    mutation ToggleMerlinPullRequestsSourcingEnabled($siteId: UUID!) {
  toggleMerlinPullRequestsSourcingEnabled(siteId: $siteId) {
    success
    message
  }
}
    `;
export type ToggleMerlinPullRequestsSourcingEnabledMutationFn = ApolloReactCommon.MutationFunction<ToggleMerlinPullRequestsSourcingEnabledMutation, ToggleMerlinPullRequestsSourcingEnabledMutationVariables>;

/**
 * __useToggleMerlinPullRequestsSourcingEnabledMutation__
 *
 * To run a mutation, you first call `useToggleMerlinPullRequestsSourcingEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleMerlinPullRequestsSourcingEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleMerlinPullRequestsSourcingEnabledMutation, { data, loading, error }] = useToggleMerlinPullRequestsSourcingEnabledMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useToggleMerlinPullRequestsSourcingEnabledMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleMerlinPullRequestsSourcingEnabledMutation, ToggleMerlinPullRequestsSourcingEnabledMutationVariables>) {
        return ApolloReactHooks.useMutation<ToggleMerlinPullRequestsSourcingEnabledMutation, ToggleMerlinPullRequestsSourcingEnabledMutationVariables>(ToggleMerlinPullRequestsSourcingEnabledDocument, baseOptions);
      }
export type ToggleMerlinPullRequestsSourcingEnabledMutationHookResult = ReturnType<typeof useToggleMerlinPullRequestsSourcingEnabledMutation>;
export type ToggleMerlinPullRequestsSourcingEnabledMutationResult = ApolloReactCommon.MutationResult<ToggleMerlinPullRequestsSourcingEnabledMutation>;
export type ToggleMerlinPullRequestsSourcingEnabledMutationOptions = ApolloReactCommon.BaseMutationOptions<ToggleMerlinPullRequestsSourcingEnabledMutation, ToggleMerlinPullRequestsSourcingEnabledMutationVariables>;
export const ToggleSlicesApiEnabledDocument = gql`
    mutation ToggleSlicesAPIEnabled($siteId: UUID!) {
  toggleSlicesAPIEnabled(siteId: $siteId) {
    success
    message
  }
}
    `;
export type ToggleSlicesApiEnabledMutationFn = ApolloReactCommon.MutationFunction<ToggleSlicesApiEnabledMutation, ToggleSlicesApiEnabledMutationVariables>;

/**
 * __useToggleSlicesApiEnabledMutation__
 *
 * To run a mutation, you first call `useToggleSlicesApiEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleSlicesApiEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleSlicesApiEnabledMutation, { data, loading, error }] = useToggleSlicesApiEnabledMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useToggleSlicesApiEnabledMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleSlicesApiEnabledMutation, ToggleSlicesApiEnabledMutationVariables>) {
        return ApolloReactHooks.useMutation<ToggleSlicesApiEnabledMutation, ToggleSlicesApiEnabledMutationVariables>(ToggleSlicesApiEnabledDocument, baseOptions);
      }
export type ToggleSlicesApiEnabledMutationHookResult = ReturnType<typeof useToggleSlicesApiEnabledMutation>;
export type ToggleSlicesApiEnabledMutationResult = ApolloReactCommon.MutationResult<ToggleSlicesApiEnabledMutation>;
export type ToggleSlicesApiEnabledMutationOptions = ApolloReactCommon.BaseMutationOptions<ToggleSlicesApiEnabledMutation, ToggleSlicesApiEnabledMutationVariables>;
export const ToggleGatsbyjsioEnabledDocument = gql`
    mutation ToggleGatsbyjsioEnabled($siteId: UUID!) {
  toggleGatsbyjsioEnabled(siteId: $siteId) {
    success
    message
  }
}
    `;
export type ToggleGatsbyjsioEnabledMutationFn = ApolloReactCommon.MutationFunction<ToggleGatsbyjsioEnabledMutation, ToggleGatsbyjsioEnabledMutationVariables>;

/**
 * __useToggleGatsbyjsioEnabledMutation__
 *
 * To run a mutation, you first call `useToggleGatsbyjsioEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleGatsbyjsioEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleGatsbyjsioEnabledMutation, { data, loading, error }] = useToggleGatsbyjsioEnabledMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useToggleGatsbyjsioEnabledMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleGatsbyjsioEnabledMutation, ToggleGatsbyjsioEnabledMutationVariables>) {
        return ApolloReactHooks.useMutation<ToggleGatsbyjsioEnabledMutation, ToggleGatsbyjsioEnabledMutationVariables>(ToggleGatsbyjsioEnabledDocument, baseOptions);
      }
export type ToggleGatsbyjsioEnabledMutationHookResult = ReturnType<typeof useToggleGatsbyjsioEnabledMutation>;
export type ToggleGatsbyjsioEnabledMutationResult = ApolloReactCommon.MutationResult<ToggleGatsbyjsioEnabledMutation>;
export type ToggleGatsbyjsioEnabledMutationOptions = ApolloReactCommon.BaseMutationOptions<ToggleGatsbyjsioEnabledMutation, ToggleGatsbyjsioEnabledMutationVariables>;
